// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { MtlsSecretRef, MtlsSecretRefT, verifyMtlsSecretRef } from "./mtls-secret-ref";

/**
 * GET /channels/mtls-secrets response — a flat list of selectable
 * secret references for the wizard's mTLS secret dropdown.
 */
export class MtlsSecretsResponse implements flatbuffers.IUnpackableObject<MtlsSecretsResponseT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): MtlsSecretsResponse {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsMtlsSecretsResponse(
    bb: flatbuffers.ByteBuffer,
    obj?: MtlsSecretsResponse,
  ): MtlsSecretsResponse {
    return (obj || new MtlsSecretsResponse()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsMtlsSecretsResponse(
    bb: flatbuffers.ByteBuffer,
    obj?: MtlsSecretsResponse,
  ): MtlsSecretsResponse {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new MtlsSecretsResponse()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  secrets(index: number, obj?: MtlsSecretRef): MtlsSecretRef | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new MtlsSecretRef()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  secretsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  static startMtlsSecretsResponse(builder: flatbuffers.Builder) {
    builder.startObject(1);
  }

  static addSecrets(builder: flatbuffers.Builder, secretsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, secretsOffset, 0);
  }

  static createSecretsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startSecretsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static endMtlsSecretsResponse(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // secrets
    return offset;
  }

  static createMtlsSecretsResponse(
    builder: flatbuffers.Builder,
    secretsOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    MtlsSecretsResponse.startMtlsSecretsResponse(builder);
    MtlsSecretsResponse.addSecrets(builder, secretsOffset);
    return MtlsSecretsResponse.endMtlsSecretsResponse(builder);
  }

  unpack(): MtlsSecretsResponseT {
    return new MtlsSecretsResponseT(
      this.bb!.createObjList<MtlsSecretRef, MtlsSecretRefT>(
        this.secrets.bind(this),
        this.secretsLength(),
      ),
    );
  }

  unpackTo(_o: MtlsSecretsResponseT): void {
    _o.secrets = this.bb!.createObjList<MtlsSecretRef, MtlsSecretRefT>(
      this.secrets.bind(this),
      this.secretsLength(),
    );
  }

  unpackFields(...fields: string[]): MtlsSecretsResponseT {
    const t = new MtlsSecretsResponseT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("secrets")) {
      t.secrets = this.bb!.createObjList<MtlsSecretRef, MtlsSecretRefT>(
        this.secrets.bind(this),
        this.secretsLength(),
      );
    }
    return t;
  }
}

export class MtlsSecretsResponseT implements flatbuffers.IGeneratedObject {
  constructor(public secrets: MtlsSecretRefT[] = []) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.secrets === null || this.secrets === undefined) {
      throw new Error('Required field "secrets" is not set');
    }
    const secrets = MtlsSecretsResponse.createSecretsVector(
      builder,
      builder.createObjectOffsetList(this.secrets),
    );

    return MtlsSecretsResponse.createMtlsSecretsResponse(builder, secrets);
  }

  clone(): MtlsSecretsResponseT {
    const obj = new MtlsSecretsResponseT();
    obj.secrets = this.secrets.map((e) => e.clone());
    return obj;
  }

  equals(other: MtlsSecretsResponseT): boolean {
    if (this.secrets.length !== other.secrets.length) return false;
    for (let i = 0; i < this.secrets.length; i++) {
      const a = this.secrets[i];
      const b = other.secrets[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    return true;
  }
}

export function verifyMtlsSecretsResponse(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyMtlsSecretRef);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "secrets");
  } finally {
    verifier.popDepth();
  }
}
